import { Contact } from "@models/contact"

export class UserStore {
  constructor(
    public currentUserContact: Contact = null
  ) {}
}




// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/store/user.ts